import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import History from "./pages/History";
import TubRefinishing from "./pages/TubRefinishing";
import WallTileRefinishing from "./pages/WallTileRefinishing";
import Countertops from "./pages/Countertops";
import ColorChoices from "./pages/ColorChoices";
import Showroom from "./pages/Showroom";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Billing from "./pages/Billing";
import Payment from "./pages/Payment";
import Dashboard from "./pages/Dashboard";
import LeaveReview from "./pages/LeaveReview";
import AuthCallback from "./pages/AuthCallback";
import { TubTileFaq, CountertopsFaq } from "./pages/Faqs";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
      </Layout>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/our-history-and-experience" element={<History />} />
        <Route path="/tub-refinishing" element={<TubRefinishing />} />
        <Route path="/wall-tile-refinishing" element={<WallTileRefinishing />} />
        <Route path="/countertops" element={<Countertops />} />
        <Route path="/color-choices" element={<ColorChoices />} />
        <Route path="/tub-tile-faq" element={<TubTileFaq />} />
        <Route path="/countertops-faq" element={<CountertopsFaq />} />
        <Route path="/showroom" element={<Showroom />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/make-a-payment" element={<Payment />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/leave-a-review/:token" element={<LeaveReview />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
